// @flow
import React, { useEffect, useState } from 'react';
import { useViewport } from 'components/templates/viewportProvider';
import { OverlayPortal } from 'components/templates/overlayPortal';
import { OverlayModal } from 'components/templates/overlayModal';
import playButton from 'assets/images/Play-Button-S.png';
//eslint-disable-next-line
import styles from "./styles.scss";

type Props = {
  videoUrl: string,
};

export const BannerVideoButton = (props: Props) => {
  const { isMobile } = useViewport();
  const { videoUrl } = props;
  const [showVideoOverlay, setShowVideoOverlay] = useState(false);

  useEffect(() => {
    videoUrl &&
      setTimeout(() => {
        setShowVideoOverlay(true);
      }, 2000);
  }, [videoUrl]);

  let videoButtonClassName = 'section-footer play-button';
  if (isMobile) {
    videoButtonClassName = 'play-button';
  }

  const videoOverlay = showVideoOverlay ? (
    <OverlayPortal>
      <OverlayModal
        data={videoUrl}
        theme={'dark-theme'}
        type={'video-overlay'}
        className={'banner-video'}
        onClosePress={() => setShowVideoOverlay(false)}
        breadcrumbList={[]}
      />
    </OverlayPortal>
  ) : null;

  return (
    <>
      <div className={videoButtonClassName}>
        {!isMobile && <h4>Play Video</h4>}
        <img
          className={'play-icon'}
          src={playButton}
          alt={'play-icon'}
          onClick={() => setShowVideoOverlay(true)}
        />
      </div>
      {videoOverlay}
    </>
  );
};
